import { render, staticRenderFns } from "./Privacy.vue?vue&type=template&id=abcdf1fc&scoped=true&"
var script = {}
import style0 from "./Privacy.vue?vue&type=style&index=0&id=abcdf1fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abcdf1fc",
  null
  
)

export default component.exports